<style lang="stylus" scoped>
@import '../css/var'
@import '../css/iconfont'
.grid
  display flex
  flex-direction column
  align-items center

.container
  width pt(120)
  height pt(120)
  border-radius pt(55)
  display flex
  align-items center
  justify-content: center;

.success
  background white
  border 1px solid #30C27C

.failure
  background #F86E6B

.tipClass
  text-align center
  margin-top pt(30) 
  font-size $normal-font-size

.successColor
  color #30C27C

.failureColor
  color white 

.failureTipColor
  $normal-text-color

.icon{
  font-family:"iconfont" !important;
  font-size:pt(50);font-style:normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
</style>
<template>
<div class="grid">
 <div class="container" :class="isSuccess === true ? 'success' : 'failure'">
   <div v-if='isSuccess'>
   <i class="icon successColor">&#xe66e;</i>
   </div>
   <div v-if='!isSuccess'>
   <i class="icon failureColor">&#xe6f3;</i>
   </div>
  </div>
  <div class="tipClass" :class="isSuccess === true ? 'successColor' : 'failureTipColor'">{{tip}}</div>
</div>
</template>
<script>
export default {
  props: {
    isSuccess: undefined,
    tip: ''
  }
}
</script>


// WEBPACK FOOTER //
// message.vue?a6415f92